import { AiUserSubscription, BillingCycle } from '../../types'
import { PriceType } from './constants'

export enum TrainingSpeed {
  NORMAL = 'normal',
  PRIORITY = 'priority'
}

// MUST map from ISO currency to symbol
export enum CurrencySymbols {
  USD = '$',
  BRL = 'R$'
}

export const getISOCurrencyFromSymbol = (symbol: CurrencySymbols) => {
  const keys = Object.keys(CurrencySymbols) as (keyof typeof CurrencySymbols)[]
  return keys.find((key) => CurrencySymbols[key] === symbol)
}

export type GetPriceIdType = typeof BaseTier.prototype.getPriceId

export abstract class BaseTier {
  abstract subscriptionType: AiUserSubscription
  abstract subscriptionLevel: number // the order in the hierarchy of the subscription
  abstract vocalLimitMinutes: number
  abstract downloadMsPerMonth: number
  abstract textToSpeechCharacterLimit: number
  abstract trainingSpeed: TrainingSpeed
  abstract modelSlots: number
  abstract maxTrainDatasetFileSizeMb: number
  abstract maxTrainingDatasetMb: number
  abstract maxTrainingDatasetDurationMinutes: number
  abstract maxYoutubeTrainingVideoLengthMinutes: number
  abstract youtubeConvertsPerDay: number
  abstract textToSpeechCharacterConverts: number
  abstract maxMlTrainingJobsPerMonth: number

  abstract inferenceSecondsPerMonth: number

  abstract advancedSettingsEnabled: boolean
  abstract artistVoiceModelsEnabled: boolean

  abstract currencySymbol: CurrencySymbols
  abstract monthlyPrice: number
  abstract annualPrice: number

  abstract getPriceId(billingCycle: BillingCycle, isProd: boolean): PriceType | null
}
